<template>
  <div class="animated fadeIn upload-prk">
    <b-card v-if="!showUploadFrm">
      <div slot="header">
        Hasil Import Data Write Off
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="saveimportdata()">
            <i class="fa fa-save"></i> Save
          </button>
          <button class="btn btn-primary mr-1" @click="cancel()">
            <i class="fa fa-close"></i> {{$t('close')}}
          </button>
        </div>
      </div>
      <b-card no-body>
        <template v-slot:header v-if="(filterShow=='Hide')">
          <b-row>
            <b-col lg="3">
              <b-input-group size="sm" class="mt-1">
                <b-input-group-prepend>
                  <span class="pt-1 mr-1">FILTER</span>
                </b-input-group-prepend>
                <b-form-input
                  v-model="filter"
                  type="search"
                  id="filterInput"
                  placeholder="Type to Search"
                ></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="clearFilter">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
              <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                <b>{{ filterShow }}</b> Filter
              </b-form-checkbox>
            </b-col>
            <b-col lg="9">
              <b-form-group
                label="FILTER ON :"
                label-cols-sm="1"
                description="Leave all unchecked to filter on all data"
                class="mb-0"
              >
                <b-form-checkbox-group v-model="filterOn" class="mt-1">
                  <b-form-checkbox value="rekonsil">Rekon Status</b-form-checkbox>
                  <b-form-checkbox value="uraian1">Description Sub Modul</b-form-checkbox>
                  <b-form-checkbox value="uraian2">Description GL</b-form-checkbox>
                  <b-form-checkbox value="nilai1">Value Sub Modul</b-form-checkbox>
                  <b-form-checkbox value="nilai2">Value GL</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
        </template>
        <b-table
          class="mb-0 text-nowrap"
          ref="tableOri"
          sticky-header="600px"
          outlined
          responsive
          striped
          hover
          style="font-size:smaller;"
          :items="rptLines"
          :fields="tblLcy.fields"
          :current-page="tblLcy.page"
          :per-page="tblLcy.limit"
          :sort-by.sync="tblLcy.sortBy"
          :sort-desc.sync="tblLcy.sortDesc"
          :filter="filter"
          :filterIncludedFields="filterOn"
          @filtered="onFiltered"
        >
          <template v-slot:cell(tgl_kontrak)="data">
            <span v-if="(data.item.tgl_kontrak)">{{ data.item.tgl_kontrak | moment("DD-MMM-YYYY") }}</span>
          </template>
          <template
            v-slot:cell(principal)="data"
          >{{ data.item.principal | numFormat('0,0.00') }}</template>
          <template
            v-slot:cell(bunga_tarifthn)="data"
          >{{ data.item.bunga_tarifthn | numFormat('0,0.00') }}</template>
          <template
            v-slot:cell(interest)="data"
          >{{ data.item.interest | numFormat('0,0.00') }}</template>
          <template
            v-slot:cell(interest_outstand)="data"
          >{{ data.item.interest_outstand | numFormat('0,0.00') }}</template>
           <template
            v-slot:cell(paym_total_amount)="data"
          >{{ data.item.paym_total_amount | numFormat('0,0.00') }}</template>
           <template
            v-slot:cell(principal_outstand)="data"
          >{{ data.item.principal_outstand | numFormat('0,0.00') }}</template>
           <template
            v-slot:cell(installment_amount)="data"
          >{{ data.item.installment_amount | numFormat('0,0.00') }}</template>
           <template
            v-slot:cell(denda_tarifhri)="data"
          >{{ data.item.denda_tarifhri | numFormat('0,0.00') }}</template>

          <template v-slot:custom-foot>
            <b-tr>
              <b-td colspan="10">
                <h6 class="text-right">Sub Total:</h6>
              </b-td>
              <!-- <b-td>
                <h6 class="text-right">{{sum_denda_tarifhri | numFormat('0,0.00')}}</h6>
              </b-td> -->
              <b-td>
                <h6 class="text-right">{{sum_paym_total_amount | numFormat('0,0.00')}}</h6>
              </b-td>
              <b-td>
                <h6 class="text-right">{{sum_principal_outstand | numFormat('0,0.00')}}</h6>
              </b-td>
              <b-td>
                <h6 class="text-right">{{sum_interest_outstand | numFormat('0,0.00')}}</h6>
              </b-td>
              <b-td>
                &nbsp;
              </b-td>
            </b-tr>
          </template>

        </b-table>
        <b-row class="mt-2">
          <!-- <b-col lg="8">
            <b-row>
              <b-col cols="6">
                <b-form-checkbox
                  v-model="filterShow"
                  value="Hide"
                  unchecked-value="Show"
                  switch
                  class="ml-2"
                >
                  <b>{{ filterShow }}</b> Filter
                </b-form-checkbox>
                Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
                    to
                    <span
                      v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)"
                    >{{tblLcy.total}}</span>
                    <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
                    of {{tblLcy.total}} entries,
              </b-col>
              <b-col cols="6">
                <div style="display: flex;margin:0;padding:0;">
                  <div style="margin:0;padding:5px;width:500px; text-align:right;">
                    Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
                    to
                    <span
                      v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)"
                    >{{tblLcy.total}}</span>
                    <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
                    of {{tblLcy.total}} entries,
                    <span
                      class="mr-1"
                    >limit per page :</span>
                    <select v-model="tblLcy.limit" style="width:60px;">
                      <option>10</option>
                      <option>15</option>
                      <option>20</option>
                      <option>25</option>
                      <option>30</option>
                      <option>40</option>
                      <option>50</option>
                      <option>60</option>
                      <option>70</option>
                      <option>80</option>
                      <option>90</option>
                    </select>
                  </div>
                  <div>
                    <b-pagination
                      class="ml-1"
                      align="left"
                      :total-rows="tblLcy.total"
                      :per-page="tblLcy.limit"
                      v-model="tblLcy.page"
                    ></b-pagination>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col> -->
          <b-col cols="4">
                <!-- <b-form-checkbox
                  v-model="filterShow"
                  value="Hide"
                  unchecked-value="Show"
                  switch
                  class="ml-2"
                >
                  <b>{{ filterShow }}</b> Filter
                </b-form-checkbox> -->
                Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
                    to
                    <span
                      v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)"
                    >{{tblLcy.total}}</span>
                    <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
                    of {{tblLcy.total}} entries,
              </b-col>
              <b-col cols="4">
                <div style="display: flex;margin:0;padding:0;">
                  <div style="margin:0;padding:5px;width:500px; text-align:center;">
                    <!-- Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
                    to
                    <span
                      v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)"
                    >{{tblLcy.total}}</span>
                    <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
                    of {{tblLcy.total}} entries, -->
                    <span
                      class="mr-1"
                    >limit per page :</span>
                    <select v-model="tblLcy.limit" style="width:60px;">
                      <option>10</option>
                      <option>15</option>
                      <option>20</option>
                      <option>25</option>
                      <option>30</option>
                      <option>40</option>
                      <option>50</option>
                      <option>60</option>
                      <option>70</option>
                      <option>80</option>
                      <option>90</option>
                    </select>
                  </div>
                  <!-- <div>
                    <b-pagination
                      class="ml-1"
                      align="left"
                      :total-rows="tblLcy.total"
                      :per-page="tblLcy.limit"
                      v-model="tblLcy.page"
                    ></b-pagination>
                  </div> -->
                </div>
              </b-col>
          <b-col lg="4">
            <!-- <b-row align-h="right">
              <b-col md="5">
                <b-form-group label="Total Sisa Pokok">
                  <my-number
                    class="form-control text-right"
                    v-model="subtotal.totalModul"
                    :precision="2"
                    disabled
                  ></my-number>
                </b-form-group>
              </b-col>
              <b-col md="5">
                <b-form-group label="Total Sisa Bunga">
                  <my-number
                    class="form-control text-right"
                    v-model="subtotal.totalGl"
                    :precision="2"
                    disabled
                  ></my-number>
                </b-form-group>
              </b-col>
            </b-row> -->
            <div>
                    <b-pagination
                      class="ml-1"
                      align="right"
                      :total-rows="tblLcy.total"
                      :per-page="tblLcy.limit"
                      v-model="tblLcy.page"
                    ></b-pagination>
                  </div>
          </b-col>
        </b-row>
      </b-card>
    </b-card>
    <b-row align-h="center" v-else>
      <b-col md="8">
        <b-card>
          <div slot="header">
            Import Data Write Off
            <div class="card-header-actions">
              <div>
                <b-button class="btn-normal alert mb-2 mr-2" @click="close">
                  <i class="fa fa-times"></i> Close
                </b-button>
              </div>
            </div>
          </div>

          <b-card class="ColsDefine">
            <strong>Difinisi nama Kolom Excel untuk setiap Field pada data Pinjaman</strong>
            <b-row>
              <b-col lg="4">
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Debitur No</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.CustCode" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Nama Debitur</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.CustName" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>No. KTP Debitur</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.ktp" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Alamat Debitur</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.alamat" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Kelurahan Debitur</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.kelurahan" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Kecamatan Debitur</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.kecamatan" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Kota Debitur</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.kota" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Kodepos Debitur</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.kodepos" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
              </b-col>
              <b-col lg="4">
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Pokok Pinjaman</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.principal" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Jk.Waktu Pinjaman</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.tenor" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Tarif Bunga(%)/Tahun</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.bunga_tarifthn" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Total Bunga</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.interest" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Angsuran Per Bulan</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.installment_amount" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                 <b-input-group>
                  <b-input-group-prepend>
                    <label>Tarif Denda Harian</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.denda_tarifhri" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Total Pembayaran</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.paym_total_amount" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Sisa Pokok</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.principal_outstand" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Sisa Bunga</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.interest_outstand" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
              </b-col>
              <b-col lg="4">
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Terakhir Angsuran ke-</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.paym_install_no" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>No. Application</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.application_no" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>No. Kontrak</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.no_kontrak" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Tgl. Kontrak</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.tgl_kontrak" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Tujuan Penggunaan</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.uraian" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Status Collection</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.collectability" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
              </b-col>
            </b-row>
          </b-card>
          <b-input-group>
            <b-input-group-prepend>
              <label>Choose *.XLSX file</label>
            </b-input-group-prepend>
            <b-form-file
              v-model="fileXlsx"
              :state="!$v.fileXlsx.$error"
              placeholder="Choose a XLSX file..."
              drop-placeholder="Drop XLSX file here..."
            ></b-form-file>
          </b-input-group>
          <b-row no-gutters>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Nama SHEET</label>
                </b-input-group-prepend>
                <b-form-input v-model="frmUpload.sheetName" :state="!$v.frmUpload.sheetName.$error"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="5">
              <b-input-group>
                <b-input-group-append>
                  <label class="input-group-text ml-1">Data mulai baris ke-</label>
                </b-input-group-append>
                <b-form-input
                  v-model="frmUpload.startRow"
                  type="number"
                  :state="!$v.frmUpload.startRow.$error"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <div slot="footer" class="text-center">
            <b-button variant="primary" @click="importdata()">Import</b-button>
            <b-button variant="danger" @click="close()">Close</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>
.upload-prk {
  iframe {
    border: 1px solid #ccc;
    width: 100%;
    height: 11in;
  }
  .ColsDefine {
    .input-group {
      .input-group-prepend {
        label {
          width: 135px !important;
        }
      }
    }
  }
}
</style>

<script>
import moment from "moment";
// import arreport from "../../apis/arreport";
import myNumber from "../../components/my-number";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import klmXls from "../../data/kolomXls"
import pinjaman from "../../apis/pinjamankredit";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmUpload: {
      sheetName: { required },
      startRow: { required },
      CustCode: { required },
      CustName: { required },
      // uraian1: { required },
      // invoiceno: { required },
      // invdate: { required },
      // artype: { required },
      // matauang: { required },
      // ttlgross: { required },
      // ttlnetto: { required },
      // ttlvat: { required },
      // ttlamtdue: { required },
    },
    fileXlsx: { required }
  },
  data() {
    return {
      showUploadFrm: true,
      fileXlsx: null,
      frmUpload: {
        sheetName: "DAFTAR_PINJAMAN_PAB",
        startRow: 4,
        application_no:'B',
        no_kontrak:'A',
        tgl_kontrak:"DQ",
        CustCode: "C",
        CustName: "D",
        alamat:"CZ",
        uraian:'M',
        principal: 'FB',
        tenor:"CR",
        bunga_tarifthn:"P",
        interest:"FA",
        installment_amount:"DI",
        denda_tarifhri:"GD",//EV
        paym_total_amount:"FB",
        principal_outstand:"AL",
        interest_outstand:"AM",
        paym_install_no:"BH",
        //,jnsjaminan:"DD"
      },
      kolomXls: klmXls,
      isLoading: false,
      showReport: false,
      reportUrl: `${location.origin}/#load`,
      model: { account: "", tgl1: "", tgl2: "" },
      uanguser: this.$store.state.user.matauang,
      accounts: [],
      rptLines: [],
      subtotal: {},
      sum_paym_total_amount: 0,
      sum_principal_outstand: 0,
      sum_interest_outstand: 0,
      sum_denda_tarifhri: 0,
      filterShow: "Show",
      tblLcy: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields: [
          {
            key: "no_kontrak",
            label: "No.Kontrak",
            sortable: true,
          },
          {
            key: "tgl_kontrak",
            label: "tgl. Kontrak",
            thStyle: "width:90px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "CustName",
            label: "Nama Debitur",
          },
          {
            key: "alamat",
            label: "Alamat Debitur",
            sortable: true,
          },
          {
            key: "principal",
            label: "Pokok Pinjaman",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "tenor",
            label: "Jk.Waktu",
            thStyle: "width:60px",
            thClass: "text-center text-success",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "bunga_tarifthn",
            label: "Bunga(%)",
            thStyle: "width:80px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "interest",
            label: "Total Bunga",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "installment_amount",
            label: "Angsuran per bulan",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "denda_tarifhri",
            label: "Tarif Denda Harian",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "paym_total_amount",
            label: "Total Pembayaran",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "principal_outstand",
            label: "Sisa Pokok",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "interest_outstand",
            label: "Sisa Bunga",
            thStyle: "width:140px",
            thClass: "text-right ",
            tdClass: "text-right",
          },
          {
            key: "paym_install_no",
            label: "Angsuran ke-",
            thStyle: "width:140px",
            thClass: "text-right text-warning",
            tdClass: "text-right",
          },
        ],
      },
      filter: null,
      filterOn: [],
    };
  },
  components: { Loading, myNumber },
  computed: {
    invalidFrmUpload() {
      this.$v.frmUpload.$touch();
      return this.$v.frmUpload.$invalid;
    },
    invalidFileXlsx() {
      this.$v.fileXlsx.$touch();
      return this.$v.fileXlsx.$invalid;
    }
  },
  watch: {
  },
  // created: async function(){
  // },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblLcy.total = filteredItems.length;
      this.tblLcy.page = 1;
    },
    clearFilter() {
      this.filterOn = [];
      this.filter = "";
    },
    async importdata() {
      if (this.invalidFileXlsx || this.invalidFrmUpload) {
        toastr.error("Please fill the form correctly.");
      } else {
        try {
          this.isLoading = true;
          const result = await pinjaman.importdtPABxls(this.fileXlsx, this.frmUpload);
          //console.log("#result: ", result);
          
          let sum_paym_total_amount = 0;
          let sum_principal_outstand = 0;
          let sum_interest_outstand = 0;
          let sum_denda_tarifhri = 0;
          result.map((dt) => {
            sum_paym_total_amount += dt.paym_total_amount;
            sum_principal_outstand += dt.principal_outstand;
            sum_interest_outstand += dt.interest_outstand;
            sum_denda_tarifhri += dt.denda_tarifhri;
          });
          // console.log("#sum_paym_total_amount: ", sum_paym_total_amount);
          // console.log("#sum_principal_outstand: ", sum_principal_outstand);
          // console.log("#sum_interest_outstand: ", sum_interest_outstand);
          // console.log("#sum_denda_tarifhri: ", sum_denda_tarifhri);

          this.rptLines = result;
          // console.log("#result: ", result);
          this.sum_paym_total_amount = sum_paym_total_amount;
          this.sum_principal_outstand = sum_principal_outstand;
          this.sum_interest_outstand = sum_interest_outstand;
          this.sum_denda_tarifhri = sum_denda_tarifhri;

          this.showUploadFrm = false;
          this.tblLcy.total = result.length;
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
     async saveimportdata() {
      if (this.rptLines.length==0) {
        toastr.warn("Data is empty");
      } else {
         try {
          await pinjaman.savebulkdtPAB(this.rptLines);
          this.showUploadFrm = true;
          toastr.success('Data berhasil diimport');
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    close() {
      router.push("home");
    },
    cancel(){
      this.showUploadFrm=true;
      this.rptLines=[];
    }
  },
};
</script>
